module.exports = __webpack_public_path__ + "static/media/empty.c5d9c683.svg";